import Footer from "components/footer/Footer";
import HeaderV2 from "components/header/HeaderV2";
import Level from "components/level/Level";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import LogoBlack from "../../assets/svg/railyard-logo-black.svg";

const RedirectToBooking = () => {
  const showLevel = useSelector((state) => state.level.showLevel);
  const [timer, setTimer] = useState(5);
  const [searchParams] = useSearchParams();

  const bookingUrl =
    searchParams.get("bookingUrl") ||
    "https://bookings.downingstudents.com/Pages/Login/Login.aspx?wf=Login&__hstc=174505149.999b663b6e1c2fc57b91a50469e4305b.1759154471817.1762174032034.1762234987822.6&__hssc=174505149.2.1762234987822&__hsfp=730268590";

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      window.open(bookingUrl, "_blank");
    }
  }, [timer, bookingUrl]);
  return (
    <div className="flex flex-col">
      <div className="relative">
        {showLevel && (
          <div className="fixed top-0 left-0 right-0 z-[99]">
            <Level />
          </div>
        )}
        <HeaderV2
          headerContainerClass={`fixed top-0 left-0 right-0 z-[99] transition-all ${
            showLevel ? "duration-500" : "duration-200"
          } ease-out ${
            showLevel
              ? "translate-y-[40px] bg-primary-black"
              : "translate-y-0 bg-primary-black"
          }`}
          isHeaderSticky={false}
        />

        <div className=" bg-primary-bg">
          <div className="flex flex-col gap-4 items-center justify-center h-full pt-[120px] lg:pt-[150px] pb-[36px] px-[16px]">
            {/* <div className="flex items-center gap-2">
              <Link
                to="/"
                className="hover:text-primary-black hover:underline text-[18px] font-semibold text-secondary-rectangle-one"
              >
                Home
              </Link>
              <button>
                <ChevronDownIcon className="w-4 h-4 -rotate-90" />
              </button>
              <p className="text-primary-black text-[18px] font-semibold">
                Residents Login Redirect
              </p>
            </div> */}

            <div className="w-[162px] h-[42px] lg:w-[262px] lg:h-[62px] shrink-0">
              <img
                src={LogoBlack}
                alt="Company Logo"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="flex flex-col items-center justify-center gap-4 text-center">
              <p className="text-primary-black font-medium text-[16px]">
                The Railyard is not in anyway connected or affiliated to The
                Downing College.
              </p>
              <p className="text-primary-black font-medium text-[16px]">
                You are being transferred to our main website to check
                availability
              </p>
            </div>

            <ClipLoader color={"#01162D"} size={64} />

            <div className="flex flex-col items-center justify-center gap-4 text-center">
              <p className="text-primary-black font-medium text-[16px]">
                You should be automatically redirected in{" "}
                <span className="text-primary-black font-semibold">
                  {timer} seconds
                </span>
              </p>
              <p className="text-primary-black font-medium text-[16px]">
                If you are not automatically redirected{" "}
                <button
                  onClick={() => {
                    window.open(bookingUrl, "_blank");
                  }}
                  className="text-secondary-rectangle-one underline hover:text-primary-black font-semibold"
                >
                  click here
                </button>
              </p>
            </div>
          </div>

          <div className="w-full">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedirectToBooking;
